import React, { createContext, useContext, useState, useEffect } from 'react';
import { currentEducator } from '../data/educatorPortalData';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const savedUser = localStorage.getItem('sba_educator_user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);

  const login = async (phone, otp) => {
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    if (otp === '123456') {
      const existingUser = phone === currentEducator.phone ? currentEducator : null;
      
      if (existingUser) {
        setUser(existingUser);
        setIsAuthenticated(true);
        localStorage.setItem('sba_educator_user', JSON.stringify(existingUser));
        return { success: true, isNewUser: false };
      } else {
        const newUser = { phone, isProfileComplete: false };
        setUser(newUser);
        setIsAuthenticated(true);
        localStorage.setItem('sba_educator_user', JSON.stringify(newUser));
        return { success: true, isNewUser: true };
      }
    }
    return { success: false, error: 'Invalid OTP' };
  };

  const logout = () => {
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem('sba_educator_user');
  };

  const updateProfile = (profileData) => {
    const updatedUser = { ...user, ...profileData, isProfileComplete: true };
    setUser(updatedUser);
    localStorage.setItem('sba_educator_user', JSON.stringify(updatedUser));
  };

  return (
    <AuthContext.Provider value={{ user, isLoading, isAuthenticated, login, logout, updateProfile }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
